const mobileMenuToggleHandler = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".site-header");
  const container = document.querySelector(".site-header__nav");
  if (!html || !header || !container) return;
  const toggle = container.querySelector(".site-header__menu-toggle");
  const list = container.querySelector(".site-header__list");
  const paths = toggle.querySelectorAll("path");
  if (!toggle || !list) return;
  const mobileSearchBtn = container.querySelector("#mobile_search_toggle");

  const animationPaths = [paths[0], paths[1]];
  animationPaths.forEach((path) => {
    path.style.strokeDashoffset = 0;
    path.style.strokeDasharray = 32;
  });

  let transitionTimeout;
  toggle.addEventListener("click", () => {
    html.classList.toggle("overflow-hidden");
    mobileSearchBtn.classList.toggle("hidden");
    
    ["fixed", "h-screen"].forEach((className) =>
      header.classList.toggle(className),
    );

    container.classList.toggle("flex-col");

    ["w-full", "grow", "flex"].forEach((className) =>
      list.classList.toggle(className),
    );
    ["opacity-0", "translate-x-full"].forEach((className) =>
      paths[2].classList.toggle(className),
    );

    clearTimeout(transitionTimeout);

    if (header.classList.contains("fixed")) {
      animationPaths.forEach((path) => {
        path.style.strokeDashoffset = 36;
        path.style.strokeDasharray = 36;

        transitionTimeout = setTimeout(() => {
          paths[0].setAttribute("d", "M2 28L28 4");
          paths[1].setAttribute("d", "M2 4L28 28");
          path.classList.add("transitioning");
          path.style.strokeDashoffset = 0;
          path.style.strokeDasharray = 36;
          path.addEventListener("transitionend", () => {
            path.classList.remove("transitioning");
          });
        }, 10);
      });
    } else {
      animationPaths.forEach((path) => {
        path.style.strokeDashoffset = 32;
        path.style.strokeDasharray = 32;

        transitionTimeout = setTimeout(() => {
          paths[0].setAttribute("d", "M2 4L30 4");
          paths[1].setAttribute("d", "M2 28L30 28");
          path.classList.add("transitioning");
          path.style.strokeDashoffset = 0;
          path.style.strokeDasharray = 32;
          path.addEventListener("transitionend", () => {
            path.classList.remove("transitioning");
          });
        }, 10);
      });
    }
  });

  const handleResize = () => {
    const lgScreen = 1024;
    if (window.innerWidth >= lgScreen) {
      html.classList.remove("overflow-hidden");
      mobileSearchBtn.classList.remove("hidden");
      container.classList.remove("flex-col");

      ["fixed", "h-screen"].forEach((className) =>
        header.classList.remove(className),
      );
      ["w-full", "grow", "flex"].forEach((className) =>
        list.classList.remove(className),
      );

      if (paths.length < 3) return;
      ["opacity-0", "translate-x-full"].forEach((className) =>
        paths[2].classList.remove(className),
      );

      paths[0].setAttribute("d", "M0 4L32 4");
      paths[1].setAttribute("d", "M0 28L32 28");
      animationPaths.forEach((path) => {
        path.style.strokeDashoffset = 0;
        path.style.strokeDasharray = 32;
      });
    }
  };

  window.addEventListener("resize", handleResize);
};

const menuItemHandler = () => {
  const menuItems = document.querySelectorAll("#menu .nav__item");
  if (!menuItems.length) return;

  const currentUrl = window.location.href.replace(/\/$/, "");
  menuItems.forEach((item) => {
    const link = item.querySelector("a");
    if (!link) return;
    const linkUrl = new URL(link.href, window.location.origin).href.replace(/\/$/, "");

    if (currentUrl === linkUrl) {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });
};

const searchToggleHandler = () => {
  const container = document.querySelector(".site-header");
  if (!container) return;
  const mobileSearchBtn = container.querySelector("#mobile_search_toggle");
  const desktopSearchBtn = container.querySelector("#desktop_search_toggle");
  const searchInput = container.querySelector("#header_search_bar");

  const closeBtn = container.querySelector(".btn--close");
  if (!closeBtn) return;

  const openSearchBar = () => {
    container.classList.add("searching");
    if (mobileSearchBtn) mobileSearchBtn.disabled = true;
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 100);
    }
  };

  if (mobileSearchBtn) mobileSearchBtn.addEventListener("click", openSearchBar);
  if (desktopSearchBtn)
    desktopSearchBtn.addEventListener("click", openSearchBar);

  closeBtn.addEventListener("click", () => {
    container.classList.remove("searching");
    if (mobileSearchBtn) mobileSearchBtn.disabled = false;
  });
};

document.addEventListener("DOMContentLoaded", () => {
  mobileMenuToggleHandler();
  menuItemHandler();
  searchToggleHandler();
});
